// src/components/ThemePagination.js
// 테마 페이지네이션을 위한 컴포넌트

import React from 'react';
import styled from 'styled-components';

const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  margin: 1.5rem 0;
  padding: 0.5rem;
`;

const PageDot = styled.button`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: none;
  background-color: ${props => props.$active ? props.theme.colors.gold : props.theme.colors.border};
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 0;
  
  &:hover {
    background-color: ${props => props.$active ? props.theme.colors.gold : props.theme.colors.borderLight};
    transform: scale(1.2);
  }
  
  &:focus {
    outline: 2px solid ${props => props.theme.colors.gold};
    outline-offset: 2px;
  }
`;

const ThemePagination = ({ totalPages, currentPage, onPageChange }) => {
  if (totalPages <= 1) return null;

  return (
    <PaginationContainer>
      {Array.from({ length: totalPages }, (_, index) => (
        <PageDot
          key={index}
          $active={currentPage === index}
          onClick={() => onPageChange(index)}
          aria-label={`Go to page ${index + 1}`}
        />
      ))}
    </PaginationContainer>
  );
};

export default ThemePagination;